import React, { useState } from 'react';
import WhatsAppConnect from '../WhatsApp/WhatsAppConnect';
import AttendantManager from '../Admin/AttendantManager';
import BillingPanel from '../Billing/BillingPanel';
import AISettings from './AISettings';
import AccessControlPanel from './AccessControlPanel';
import './SettingsPanel.css';

const SettingsPanel = ({ role }) => {
  const [active, setActive] = useState('whatsapp');
  const normalizedRole = String(role || '').toLowerCase();
  const canManageSettings = normalizedRole === 'admin' || normalizedRole === 'master';

  return (
    <div className="settings-panel">
      <div className="settings-sidebar">
        {canManageSettings && (
          <button className={active === 'ia' ? 'active' : ''} onClick={() => setActive('ia')}>IA</button>
        )}
        <button className={active === 'whatsapp' ? 'active' : ''} onClick={() => setActive('whatsapp')}>WhatsApp</button>
        <button className={active === 'billing' ? 'active' : ''} onClick={() => setActive('billing')}>Assinatura</button>
        {canManageSettings && (
          <button className={active === 'atendentes' ? 'active' : ''} onClick={() => setActive('atendentes')}>Atendentes</button>
        )}
        {canManageSettings && (
          <button className={active === 'controle' ? 'active' : ''} onClick={() => setActive('controle')}>Painel Controle</button>
        )}
      </div>
      <div className="settings-content">
        {active === 'ia' && canManageSettings && <AISettings />}
        {active === 'whatsapp' && <WhatsAppConnect />}
        {active === 'billing' && <BillingPanel />}
        {active === 'atendentes' && canManageSettings && <AttendantManager />}
        {active === 'controle' && canManageSettings && <AccessControlPanel />}
      </div>
    </div>
  );
};

export default SettingsPanel;
